import { filter } from "@suse-o11y/filter";
import { identity } from "@suse-o11y/identity";
import { isPresent } from "@suse-o11y/is-present";
import { meanBy } from "@suse-o11y/mean-by";
import { pipe } from "@suse-o11y/pipe";

export function mean(values: ReadonlyArray<null | undefined | number>): undefined | number {
	const result = pipe(values, filter(isPresent), meanBy(identity));

	return isNaN(result) ? undefined : result;
}
